import { Chat } from '../../../components/chat';
import { nanoid } from 'nanoid';

export default function PlaygroundPage() {
  const id = nanoid();

  return <Chat id={id} />;
}
